import styled, { css } from 'styled-components';

import Page from '../Page';
import { mediaMixin } from '@zillow/constellation';

// The following styles are targeting classNames that are created within the shared zillow/zrs-zillow-offers ErrorPage component.

export const StyledPage = styled(Page)`
  margin: 0 auto;

  .testing_heading {
    font-size: 34px;
    line-height: 42px;

    ${mediaMixin(
      'lg',
      css`
        font-size: 60px;
        line-height: 72px;
      `,
    )}
  }

  && [class^='Page__PageContent'] {
    display: flex;
    min-height: 100vh;
    position: relative;
  }

  && [class^='ErrorPage__CatWrapper'] {
    width: 100%;
  }

  && [class^='ErrorPage__ContentWrapper'] {
    width: 100%;
    max-width: 1232px;
  }
`;
